import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface showPaymentVoucher {
    voucher_no?: string;
    date?: string;
    supplier?: { id: number; name: string; };
    amount?: number;
    statement?: string;
}

// Show payment voucher state
export interface showPaymentVoucherState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showPaymentVoucher;
}

const initialShowPaymentVoucherState: showPaymentVoucherState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {}
}

// Show payment voucher slice
export const showPaymentVoucherSlice = createSlice({
    name: 'show_payment_voucher',
    initialState: initialShowPaymentVoucherState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setData: ( state, {payload}: PayloadAction<showPaymentVoucher> ) => {
            state.data = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<{ id: number, isOpen: boolean }> ) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
        }
    }
})